import { createFileRoute } from "@tanstack/react-router";
import { RevisionSpokePage } from "@/components/site/RevisionSpokePage";
import { revisionSpokeHead } from "@/lib/revision-spoke-head";
import { REVISION_SPOKES } from "@/lib/revision-spokes";
import { REVISION_SPOKE_META } from "@/lib/revision-spoke-meta";

export const Route = createFileRoute("/services/revisions/tore")({
  head: () => revisionSpokeHead(REVISION_SPOKE_META.tore, import.meta.env.SSR ? REVISION_SPOKES.tore : null),
  component: ToreRevisionPage,
});

function ToreRevisionPage() {
  return <RevisionSpokePage spoke={REVISION_SPOKES.tore} />;
}